import React, { useEffect, useState, memo, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import style from "../../../../styles/gri/general.module.css";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";
import {
  validateNumberInput,
  validatePercentageInput,
  validateRatio,
} from "../../../../utils/validateFields";
import { get } from "../../../../utils/api";

const StaticColumn = memo(
  ({
    inputData,
    subHeading,
    tables,
    setTables,
    errors,
    totalField,
    setErrors,
    data,
    defaultSegments,
    defaultSegments2,
    parameter,
    parameter2,
    defaultUnit,
    setDefaultUnit,
    defaultField,
    disabled1,
    disabled,
    id,
    total1,
    errorField,
    fieldName,
  }) => {
    const [total, setTotal] = useState({});
    useEffect(() => {
      const updatedTables = inputData?.map((section) => ({
        fieldName: section?.fieldName,
        rows:
          data?.[section?.fieldName]?.length > 0
            ? data[section?.fieldName]
            : defaultSegments?.map((el, i) => ({
                [parameter]: el,
                ...(parameter2 ? { [parameter2]: defaultSegments2?.[i] } : {}),
                ...(defaultUnit ? { unit: defaultUnit } : {}),
              })),
      }));

      // Compare existing tables with updatedTables
      const isSame = JSON.stringify(updatedTables) === JSON.stringify(tables);
      if (!isSame) {
        setTables(updatedTables);
      }
    }, [data]);

    // Separate useEffect to update total after tables is set
    useEffect(() => {
      if (tables.length === 0) return; // Prevent unnecessary updates

      setTotal((prev) => {
        const totals = tables?.reduce((acc, section, tableIndex) => {
          const total = section?.rows?.reduce((sum, el) => {
            return Number(sum) + Number(el?.[totalField] || 0);
          }, 0);

          return { ...acc, [tableIndex]: total };
        }, {});

        // Only update if the totals have actually changed
        const totalsString = JSON.stringify(totals);
        const prevString = JSON.stringify(prev);
        
        if (totalsString !== prevString) {
          return { ...prev, ...totals };
        }
        return prev;
      });
    }, [tables, totalField]); // Depend on tables and totalField

    // useEffect to check total against total1 whenever total changes
    useEffect(() => {
      // Only run if we have valid data and the component is properly initialized
      if (total1 !== undefined && Object.keys(total).length > 0 && errorField) {
        const currentTotal = Object.values(total).reduce(
          (sum, val) => sum + Number(val || 0),
          0
        );

        const shouldShowError = currentTotal > total1;
        const errorMessage = shouldShowError 
          ? "Breakdown Total cannot exceed total value entered above" 
          : "";

        setErrors((prev) => {
          // Only update if the error state is actually changing
          if (prev[errorField] !== errorMessage) {
            return {
              ...prev,
              [errorField]: errorMessage,
            };
          }
          return prev;
        });

        console.log(errors,"e12")
      }
    }, [total, total1, errorField]);

    const calculate = useCallback((tableIndex, fieldName) => {
      const total = tables[tableIndex].rows?.reduce((acc, el) => {
        return Number(acc) + Number(el?.[fieldName] || 0); // Sum up the field values
      }, 0);

      setTotal((prev) => ({ ...prev, [tableIndex]: total }));

      // The error handling is now done in the useEffect above
      // This prevents duplicate error setting and infinite loops
    }, [tables]);

    const handleInputChange = (
      tableIndex,
      rowIndex,
      fieldName,
      value,
      type
    ) => {
      console.log(value);
      if (type === "percentage" && !validatePercentageInput(value)) return;
      if (type === "number" && !validateNumberInput(value)) return;
      if (type === "ratio" && !validateRatio(value)) return;

      let updatedTables = [...tables];
      console.log(updatedTables, inputData);
      if (fieldName === "unit") {
        updatedTables = updatedTables?.map((table, tableIndex) => ({
          ...table,
          rows: table?.rows?.map((row) => ({ ...row, unit: value })),
        }));
        setDefaultUnit(value);
      } else updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

      const updatedErrors = { ...errors };
      if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
        delete updatedErrors[tableIndex][rowIndex][fieldName];
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }
      //   setErrors(updatedErrors);
      //   if (fieldName === "unit") {
      //     const updatedTablesWithUnits = inputData?.map((section, index) => ({
      //         ...tables[index],
      //         rows:tables[index]?.rows?.map(el=>({...el,unit:value}))
      //     }));
      //     setTables(updatedTablesWithUnits);
      // } else {
      setTables(updatedTables);
      // }
      if (fieldName === totalField) calculate(tableIndex, fieldName);
    };

    return (
      <Box>
        {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Box sx={{ display: "flex", gap: 0.5 }}>
              {section?.letter && (
                <p className={style.ques_heading}>{section.letter}</p>
              )}
              <p className={style.ques_heading}>{section.title}</p>
            </Box>

            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "10px",
                ml: 2.3,
                width: "97.5%",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                        textAlign: "center",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(totalField
                    ? [...(tables[tableIndex]?.rows || []), "Total"]
                    : tables[tableIndex]?.rows || []
                  ).map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          backgroundColor: row === "Total" && "#D8D8D8",
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "auto",
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", width: "8%" }}>
                          {`${row === "Total" ? "" : rowIndex + 1 + "."}`}
                        </TableCell>
                        {section?.fields?.map((field) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              maxWidth: field?.width,
                              minWidth: field.width,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              fontWeight:
                                (field.fieldName === parameter ||
                                  field.fieldName === parameter2) &&
                                600,
                              color:
                                (field.fieldName === parameter ||
                                  field.fieldName === parameter2) &&
                                "#1C486B",
                            }}
                          >
                            {field.fieldName === parameter ||
                            field.fieldName === parameter2 ? (
                              <p
                                style={{
                                  fontWeight: row === "Total" ? 600 : 400,
                                  fontSize: "14px",
                                  lineHeight: "16.94px",
                                  fontFamily: "inter",
                                  marginTop: "0.5rem",
                                  height: "10px",
                                  color: row === "Total" && "black",
                                }}
                              >
                                {row === "Total" &&
                                field?.fieldName === parameter
                                  ? "Total"
                                  : row[field.fieldName]}
                              </p> // Display the value as plain text if the condition is true
                            ) : row === "Total" ? (
                              totalField === field?.fieldName && (
                                <p
                                  style={{
                                    fontWeight: row === "Total" ? 600 : 400,
                                    fontSize: "14px",
                                    lineHeight: "16.94px",
                                    fontFamily: "inter",
                                    marginTop: "0.5rem",
                                    height: "10px",
                                  }}
                                >
                                  {total?.[tableIndex] || 0}
                                </p>
                              )
                            ) : field?.type === "select" ? (
                              <Select
                                disabled={
                                  disabled ||
                                  (rowIndex < defaultSegments?.length &&
                                    field.fieldName === parameter) ||
                                  (section?.fieldName === "waterInteraction"
                                    ? field.fieldName === "unit" &&
                                      rowIndex !== 0
                                    : field.fieldName === "unit" &&
                                      (defaultUnit || disabled1)
                                    ? true
                                    : false)
                                }
                                multiple={field?.multiselect}
                                multiline
                                minRows={1}
                                value={
                                  field?.multiselect
                                    ? row[field?.fieldName] || [] // Ensure value is an array for multiselect
                                    : field?.fieldName === "unit" && defaultUnit
                                    ? defaultUnit
                                    : row[field?.fieldName] || "" // Ensure value is a string for single select
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) =>
                                  field.multiselect
                                    ? selected.length > 0
                                      ? selected.join(", ")
                                      : field.placeholder || "Select"
                                    : selected || field.placeholder || "Select"
                                }
                              >
                                <MenuItem value={""} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option?.name || option} // Ensure the `value` matches the `row[field.fieldName]`
                                  >
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                          disabled={disabled}
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option?.name || option
                                            ) || false
                                          } // Check if the option is selected
                                          size="small"
                                        />
                                        {option?.name || option}
                                      </>
                                    ) : (
                                      option?.name || option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              // console.log(row,row[field.fieldName],"Checking...")
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    disabled={
                                      disabled ||
                                      (rowIndex <= defaultSegments?.length &&
                                        field.fieldName === parameter)
                                    }
                                    value={row[field.fieldName] || "Yes"}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio disabled={disabled} />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio disabled={disabled} />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                multiline
                                minRows={1}
                                disabled={
                                  disabled ||
                                  (rowIndex < defaultSegments?.length &&
                                    field.fieldName === parameter)
                                }
                                placeholder={field.placeholder}
                                type={field.type}
                                value={row[field.fieldName] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                sx={{
                                  color: "#1C486B",
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default",
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer",
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                  sx: {
                                    color:
                                      field.fieldName === parameter &&
                                      "#1C486B",
                                    "&.Mui-disabled": {
                                      color: "red", // Ensure font color change works for disabled state
                                    },
                                  },
                                }}
                              />
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 3 }}>
              {Object?.keys?.(errors?.[fieldName] || {}).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
              {errors?.[errorField] && (
                <p
                  color="error"
                  variant="caption"
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                    fontWeight: "500",
                  }}
                >
                  {errors?.[errorField]}
                </p>
              )}
            </Box>
          </div>
        ))}
      </Box>
    );
  }
);

export default StaticColumn;
